import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { it } from "flatpickr/dist/l10n/it.js";

// Connects to data-controller="ts-select"
export default class extends Controller {
  connect() {
    this.control = flatpickr(this.element, {
      altInput: true,
      altFormat: "H:i",
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i",
      locale: "it",
      time_24hr: true,
      minuteIncrement: 30,
      allowInput: false,
    });
  }
  disconnect() {
    this.control.destroy();
  }
}
